angular
  .module('App.asScrollOnClickDirective', [])
  .directive('scrollOnClick', function() {
    return {
      restrict: 'A',
      link: function(scope, $elm, attrs) {
        let idToScroll = attrs.href;
        $elm.on('click', function() {
          let $target;
          if (idToScroll) {
            $target = $(idToScroll);
          }
          else {
            $target = $elm;
          }
          $('body').animate(
            {
              scrollTop: $target.offset().top,
            },
            'slow'
          );
        });
      },
    };
  });
